import React, { useEffect } from "react";

import ApplyPage from "./apply-page";
import log from "loglevel";
//@ts-ignore
import remote from "loglevel-plugin-remote";
import {
    Accordion,
    AccordionPanel,
    ActionButton,
    ActionButtonContainer,
    BlockLink,
    DocumentLink,
    Flexbox,
    Grid,
    IconBlockLink,
    RegulatoryText,
    StyledList,
    WarningText
} from "../../theme";

let loggerApplied = false;
log.enableAll();

const shortcodeComponents = {
    accordion: Accordion,
    "accordion-panel": AccordionPanel,
    "action-button": ActionButton,
    "action-button-container": ActionButtonContainer,
    "block-link": BlockLink,
    "document-link": DocumentLink,
    grid: Grid,
    "icon-block-link": IconBlockLink,
    "regulatory-text": RegulatoryText,
    "styled-list": StyledList,
    "warning-text": WarningText
};

const initEffect = (path: string) => () => {
    if (process.env.REACT_APP_REMOTE_LOGGER && !loggerApplied) {
        remote.apply(log, {
            url: process.env.REACT_APP_REMOTE_LOGGER,
            headers: {
                "x-api-key": process.env.REACT_APP_REMOTE_TOKEN
            },
            format: (log: any) => ({
                ...log,
                application: path
            }),
            timestamp: () => new Date().getTime()
        });
        loggerApplied = true;
    }
};

const ApplyPageApplication = ({ id, path }: { id: number; path: string }) => {
    useEffect(initEffect(path), []);

    return (
        <Flexbox mx={["auto"]} width={"100%"}>
            <Flexbox
                width={"100%"}
                pb={["2rem", "2rem", "2rem", "2rem", "2rem", 0]}
                mx={[0, 0, 0, 0, 0, 6]}
                minHeight={"37.5rem"}
            >
                <ApplyPage id={id} />
            </Flexbox>
        </Flexbox>
    );
};

export default ApplyPageApplication;

export { shortcodeComponents };
